import { memo } from "react"

const Tabs = props => {

  const {
    tabs = [],
    selected,
    setSelected
  } = props

  return (
    tabs.map((item, index) => (
      <div
        key={index}
        onClick={() => setSelected(item.value)}
        className="d-flex col-md-6 justify-content-center align-items-center py-2"
        style={{
          borderBottom: `2px solid ${selected === item.value ? "#193631" : "#cfcdc8"
            }`,
          backgroundColor:
            selected === item.value ? "#193631" : "transparent",
          cursor: "pointer",
        }}
      >
        <p
          className="m-0"
          style={{
            color: selected === item.value ? "#ffffff" : "#000",
            fontWeight: selected === item.value ? "600" : "400",
          }}
        >
          {item.label}
        </p>
      </div>
    ))
  )

}

export default memo(Tabs)